import { Row as RowStyled } from '@lib/core/src/styledComponents/StyledComponents';
import palette from '@lib/core/src/theme/palette';
import { styled, Button, Stack } from '@mui/material';

import { scrollBreakpoint } from '@/pages/JamiesCapabilities/breakpoints';

export const GAP = '2vh';

export const GapWrapper = styled(Stack)({
  gap: GAP,
  width: '100%',
  height: '100%'
});

export const CreateAgentButton = styled(Button)({
  backgroundColor: palette.black,
  color: palette.white,
  height: '40px',
  lineHeight: '40px',
  borderRadius: '20px',
  padding: '10px 20px',
  border: 'none',
  cursor: 'pointer',
  textTransform: 'none',
  fontSize: '13px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: palette.grey[2600]
  }
});

export const Row = styled(RowStyled)({
  justifyContent: 'space-between'
});

export const CapabilitiesWrapper = styled(Stack)(({ theme }) => ({
  gap: `calc(${GAP} * 2)`,
  width: '100%',
  overflow: 'auto',
  [scrollBreakpoint(theme)]: {
    height: `calc(100% - 57px)`,
    overflow: 'hidden'
  }
}));
